import React from "react";
import { useIntl } from "react-intl";

import InputField from "components/atoms/InputField/InputField";

interface UnitsFieldProps {
  isRequired: boolean;
}

function UnitsField({ isRequired }: UnitsFieldProps) {
  const intl = useIntl();
  return (
    <div className="flex-row packing-list-add-item-input-large">
      <InputField
        label={intl.formatMessage({
          id: "new-request.packing-list.numberOfUnits",
          defaultMessage: "Quantity",
        })}
        type="textinput"
        placeholder={intl.formatMessage({
          id: "general.units",
          defaultMessage: "Quantity",
        })}
        onlyNumber
        field_id="units"
        validations={{
          validate: {
            onlyNumber: (v: any) => !isNaN(v) || "Please enter a valid number",
          },
          setValueAs: (v: string) => (!v ? null : v),
          shouldUnregister: true,
        }}
        required={isRequired}
      />
    </div>
  );
}

export default UnitsField;
